import { createAsyncThunk } from '@reduxjs/toolkit';
import { splitCustomFilters } from '@/utils/reports/customFieldFilters';

// Store controller reference outside component to track between requests
let drilldownControllerRef = null;

/**
 * Build params for live job pipeline drilldown.
 * Omits date_group and filter_by.date since live reports use current snapshot.
 */
const getLiveJobPipelineDrilldownParams = ({
  group = {},
  filters = {},
  drilldown = {},
  customFilter: presetCustomFilter,
}) => {
  // Custom fields travel in their own payload key; filter_by rejects a cf_ key. This builder
  // predates that and is the one drilldown in the tree that does not route through getParams,
  // so the split has to happen here too.
  const { reportFilters, customFilter } = splitCustomFilters(filters || {});
  const params = {
    filter_by: { ...reportFilters },
  };

  const resolvedCustomFilter = {
    ...customFilter,
    ...(presetCustomFilter || {}),
  };

  if (Object.keys(resolvedCustomFilter).length) {
    params.custom_filter = resolvedCustomFilter;
  }

  if (drilldown?.metric) {
    params.drilldown = drilldown;
  }
  if (group?.group_by_1) {
    params.group_by_1 = group?.group_by_1?.id ?? group?.group_by_1;
  }
  if (group?.group_by_2 !== undefined && group?.group_by_2 !== null) {
    params.group_by_2 = group?.group_by_2?.id;
  }

  return params;
};

const getLiveJobPipelineDrilldown = async (
  { group = {}, filters = {}, drilldown = {}, customFilter },
  { extra: { atsHttp } }
) => {
  if (drilldownControllerRef) {
    drilldownControllerRef.abort();
  }

  const controller = new AbortController();
  drilldownControllerRef = controller;

  try {
    const params = getLiveJobPipelineDrilldownParams({
      group,
      filters,
      drilldown,
      customFilter,
    });
    const response = await atsHttp.post(
      `/reports/live_job_pipeline/drilldown`,
      params,
      { signal: controller.signal }
    );
    return response;
  } catch (error) {
    if (error.name === 'AbortError' || error.name === 'CanceledError') {
      throw error;
    }
    throw error;
  }
};

export const fetchLiveJobPipelineDrilldown = createAsyncThunk(
  'ats-reports/live-job-pipeline/drilldown',
  getLiveJobPipelineDrilldown
);
